/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  BuilderFormStateSchema,
  BuilderUserContext, FormRootSchema,
  FormState, FormStateSchema,
  whenCreateOrEditMode,
} from '@gh/builder-shared';
import { BuilderPermission, EMPTY_INTRANET_TASK_PROGRESS } from '@gh/builder-shared-data';
import { FormMode } from '@gh/core-ui';
import {
  isIntranetTaskInProgress,
  SystemVarsAccountsIntranet, SystemVarsAccountsIntranetTaskProgress,
} from '../../../resources/model/system-vars-accounts.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SystemVarsAccountsIntranetFormState extends FormState<SystemVarsAccountsIntranet> {
  progress$ = new BehaviorSubject(EMPTY_INTRANET_TASK_PROGRESS);

  constructor(
    schemaFactory: BuilderFormSchemaFactory,
    private userContext: BuilderUserContext,
  ) {
    super(schemaFactory);
  }

  get progress(): SystemVarsAccountsIntranetTaskProgress {
    return this.progress$.value;
  }

  get isTaskInProgress(): boolean {
    return this.progress.isTaskInProgress;
  }

  setTaskInProgress(progress: SystemVarsAccountsIntranetTaskProgress): void {
    this.progress$.next(progress);
    const inProgress = isIntranetTaskInProgress(progress);
    if (inProgress && this.editable) {
      this.updateSchema({ mode: FormMode.ViewMode });
    } else if (!inProgress && this.viewMode) {
      this.build({ ...this.group.getRawValue(), progress });
    }
  }

  protected buildSchema(_: SystemVarsAccountsIntranet, { root }: FormStateSchema): FormRootSchema {
    const mode =
      (this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Accounts.EDIT) && !this.isTaskInProgress) ?
      FormMode.EditMode : FormMode.ViewMode;

    return root({
      enabled: whenCreateOrEditMode(),
      mode,
      optimisticLock: true,
      children: {
        username: { required: true },
        password: { required: true },
        loginGuid: void 0,
      },
    });
  }
}
